module.exports = __webpack_public_path__ + "img/paper-plane-black.3919afbd.svg";